import React, { useState } from 'react';
import { Box, Button, Flex, Image, ListItem, OrderedList, Radio, RadioGroup, Text } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { BiLeftArrowAlt } from "react-icons/bi";
import { useNavigate } from 'react-router-dom';
import interLogo from "../Assets/Images/interswitch_group_logo.svg.svg";
import visaLogo from "../Assets/Images/visa_inc_logo.svg.svg";
import interIcon from "../Assets/Images/interswitch_group_icon.png.svg";
import etranzactLogo from "../Assets/Images/etranzact_logo.png.svg";
import { setFormModal } from '../redux/slices/modalSlice';

const DuesPaymentDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const myDuesDetailsData = useSelector((state) => state?.myDues?.myDuesDetails) ||[];

  const feeNames = myDuesDetailsData?.map(item => item?.feeName).join(', ') || '';
  const totalAmount = myDuesDetailsData?.map(item => parseInt(item?.amountOwed)).reduce((acc, curr) => acc + curr, 0) || 0;

  const paymentDuesDetails = [
    { title: "Payment Description:", description: feeNames },
    { title: "Transaction Amount:", description: `₦${totalAmount?.toLocaleString()}` },
    { title: "Technology Usage Fee:", description: 'Dues' },
    { title: "Transaction Ref No:", description: '43578299876' },
  ];

  const paymentTypeData = [
    { title: "Interswitch", logo: interLogo },
    { title: "Visa", logo: visaLogo },
    { title: "Interswitch Pay Direct", logo: interIcon },
    { title: "eTranzact Payoutlet", logo: etranzactLogo },
  ];

  const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);

  const handlePaymentOptionChange = (value) => {
    setSelectedPaymentOption(value);
  };

  const handleSubmitPayment = () => {
    if (selectedPaymentOption !== null) {
      dispatch(setFormModal({
        status: true,
        title: "Dues",
        type: "PaymentSuccessModal",
        data: "PaymentSuccessModal"
      }));
    }
  };

  return (
    <Box p={5} minH="100vh" bg="#f7f7f7">
      {/* Header */}
      <Flex alignItems="center" gap={3} bg="#D7343926" px={[4, 8]} py={4}>
        <Box bg="#F9A36238" rounded="full" p={1} onClick={() => navigate(-1)} cursor="pointer">
          <BiLeftArrowAlt color="#D8991F" size="20px" />
        </Box>
        <Text color="#222B45" fontWeight="700" fontSize="16px">Make Payment / Event</Text>
      </Flex>

      {/* Payment Details */}
      <Flex flexDirection={{ base: 'column', lg: 'row' }} gap={8} mt={5}>
        {/* Left Side */}
        <Box flex={1} bg="white" p={[5, 8]} borderRadius="md" boxShadow="md">
          <Text fontWeight="bold" fontSize="xl" mb={6} color="red.500">Payment Details</Text>
          {paymentDuesDetails.map((item, index) => (
            <Flex key={index} justifyContent="space-between" mb={4}>
              <Text fontWeight="semibold" color="gray.600" width="40%">{item.title}</Text>
              <Text fontWeight="semibold" color="gray.800" width="60%">{item.description}</Text>
            </Flex>
          ))}

          {/* Payment Options */}
          <Box mt={10}>
            <Text fontSize="lg" fontWeight="bold" color="red.500" mb={4}>Select a Payment Platform Below</Text>
            <RadioGroup value={selectedPaymentOption} onChange={handlePaymentOptionChange}>
              <Flex flexWrap="wrap" gap={4}>
                {paymentTypeData.map((item, index) => (
                  <Flex
                    key={index}
                    direction="column"
                    align="center"
                    justify="center"
                    p={4}
                    w={{ base: "100%", md: "48%" }}
                    border="1px solid #C4C4C4"
                    borderRadius="md"
                    cursor="pointer"
                    onClick={() => setSelectedPaymentOption(item.title)}
                    bg={selectedPaymentOption === item.title ? "red.50" : "white"}
                  >
                    <Image src={item.logo} alt={item.title} height="40px" mb={2} />
                    <Radio value={item.title} colorScheme="red">{item.title}</Radio>
                  </Flex>
                ))}
              </Flex>
            </RadioGroup>
          </Box>

          {/* Pay Button */}
          <Button
            bg="red.600"
            color="white"
            w="full"
            mt={8}
            size="lg"
            borderRadius="full"
            onClick={handleSubmitPayment}
            _hover={{ bg: 'red.700' }}
          >
            Pay NGN {totalAmount?.toLocaleString()}
          </Button>
        </Box>

        {/* Right Side */}
        <Box flex={1} bg="white" p={[5, 8]} borderRadius="md" boxShadow="md">
          <Text fontWeight="bold" fontSize="xl" mb={6} color="red.500">Instructions</Text>
          <OrderedList spacing={5} color="gray.700" fontSize="sm">
            <ListItem>Please ensure your card is enabled for online payment by your bank before proceeding.</ListItem>
            <ListItem>A transaction may fail due to insufficient funds, wrong credentials, card being blacklisted, or network failure. In such cases, check with your bank for any debits before retrying.</ListItem>
            <ListItem>For Visa card payments, kindly use the Remita platform.</ListItem>
          </OrderedList>
        </Box>
      </Flex>
    </Box>
  );
};

export default DuesPaymentDetails;
